import React from "react";
import { useTranslation } from "react-i18next";
import DialogCloseButton from "../buttons/DialogCloseButton";

interface ConfirmationDialogProps {
    open: boolean;
    title: string;
    message: string;
    confirmLabel?: string;
    cancelLabel?: string;
    onConfirm: () => void;
    onCancel?: () => void;
    onClose: () => void;

    closeOnConfirm?: boolean; // default: true
    closeOnCancel?: boolean;  // default: true
}

function ConfirmationDialog({
                                open,
                                title,
                                message,
                                confirmLabel,
                                cancelLabel,
                                onConfirm,
                                onCancel,
                                onClose,
                                closeOnConfirm = true,
                                closeOnCancel = true
                            }: ConfirmationDialogProps) {

    const { t } = useTranslation();
    if (!open) return null;

    const handleConfirm = () => {
        onConfirm();
        if (closeOnConfirm) {
            onClose();
        }
    };

    const handleCancel = () => {
        if (onCancel) {
            onCancel();
        }
        if (closeOnCancel) {
            onClose();
        }
    };

    return (
        <div className="dialog-overlay" onClick={onClose}>
            <div className="dialog confirmation-dialog" onClick={e => e.stopPropagation()}>
                <DialogCloseButton onClose={onClose} />

                <div>
                    <h3>{title}</h3>
                    <p>{message}</p>
                </div>

                <div className="dialog-actions">
                    <button
                        type="button"
                        className="form-button"
                        onClick={handleConfirm}
                    >
                        {confirmLabel || t("common.button.confirm")}
                    </button>

                    <button
                        type="button"
                        className="form-button-secondary"
                        onClick={handleCancel}
                    >
                        {cancelLabel || t("common.button.cancel")}
                    </button>
                </div>
            </div>
        </div>
    );
}

export default ConfirmationDialog;